<template>
  <slide-panel
    class="create-chat-slide-panel"
    :is-mobile="false"
    :slide-right="true"
    :close-as-text="false"
    title="Create new chat"
    @panelclose="closeMenu"
  >
    <div class="mt-5">
      <el-form
        id="memberSearchForm"
        ref="memberSearchForm"
        :model="searchForm"
        @submit.native.prevent
      >
        <el-form-item prop="search">
          <template slot="label">
            <span
              aria-hidden="true"
              class="new-chat-label"
            >Search and add members</span>
            <span class="sr-only">Please search for a member</span>
          </template>
          <v-select
            v-model="searchForm.selectedMember"
            label="first_name"
            :filterable="false"
            :options="options"
            class="members-select"
            @search="onSearch"
            @input="onAddMember($event)"
          >
            <template
              slot="no-options"
              slot-scope="search"
            >
              <div v-if="search.search.trim().length == 0">
                Start typing to search for a member.
              </div>
              <div v-else>
                No results found for <em>{{ search.search }}</em>.
              </div>
            </template>
            <template
              slot="option"
              slot-scope="option"
            >
              <div class="d-flex v-select-member">
                <div class="mt-2">
                  <member-avatar
                    :member="option"
                    :size="40"
                  ></member-avatar>
                </div>
                <div class="d-flex flex-column text-section">
                  <div class="name ml-2 text-left">
                    {{ option.first_name }} {{ option.last_name }}
                  </div>
                  <div class="company ml-2">
                    {{ `${option.organisation_name ? option.organisation_name : ''} ${ option.organisation_name && option.role ? '|' : '' } ${option.role ? option.role : ''}` }}
                  </div>
                </div>
                <a
                  href="#"
                  class="ml-auto align-self-center add-link"
                >Add</a>
              </div>
            </template>
          </v-select>
        </el-form-item>
      </el-form>
    </div>

    <div class="mt-5">
      <label class="new-chat-label mb-4">Existing members</label>
      <span class="sr-only">Existing members</span>

      <div v-if="newMembers.length > 0">
        <div
          v-for="(member, index) in newMembers"
          :key="index"
          tabindex="0"
          class="existing-member d-flex align-items-center py-3"
        >
          <member-avatar
            :member="member"
            :size="40"
          ></member-avatar>
          <div class="member-item-name pl-3 mr-2">
            {{ member.first_name }} {{ member.last_name }}
          </div>
          <a
            href="javascript:void(0)"
            aria-label="remove chat member"
            class="member-item-remove ml-auto flex-shrink-0 cursor-pointer"
            @click="removeMember(member)"
          >
            Remove
          </a>
        </div>
      </div>
      <div
        v-else
        class="no-members-added"
      >
        Search for members to add to this chat.
      </div>
    </div>

    <div class="create-conversation-btn mt-5">
      <el-button
        type="primary"
        :loading="createChatLoading"
        class="w-100"
        @click="createNewChat"
      >
        Start chat
      </el-button>
    </div>
  </slide-panel>
</template>

<script>
import _ from 'lodash'
import gsApi from '@/services/gs.api'
import SlidePanel from '@/components/slide-panel/slide-panel'
import SvgCloseCross from '@/components/assets/svg-close-cross'
import MemberAvatar from '@/pages/platform/chats/avatars/member-avatar'

export default {
  	name: 'NewChatPanel',
  components: {
  		'slide-panel': SlidePanel,
    'svg-close': SvgCloseCross,
    'member-avatar': MemberAvatar,
  },
  data: () => ({
    	createChatLoading: false,
    	searchForm: {
    		selectedMember: null,
    	},
    search_member: '',
    options: [],
    newMembers: [],
  }),
  computed: {
    newMemberIds() {
      let memberIds = []
      _.each(this.newMembers, (member) => {
        memberIds.push(member.id)
      })
      return memberIds
    },
  },
  methods: {
    	onAddMember(member) {
    		this.searchForm.selectedMember = null // Workaround v-select to select a user after removal as in (add Sean, Remove Sean and then add Sean again).

      this.newMembers.push(member)
    	},
    	onSearch(search, loading) {
    		this.search(loading, search, this)
    	},
    	search: _.debounce((loading, search, vm) => {
    		if (search.trim().length > 0) {
        loading(true)

        gsApi.chat.getNewMembersList({
          search: search.trim(),
	          excluded_ids: vm.newMemberIds
        }).then((response) => {
	        	loading(false)

	          if (response && response.data) {
	            vm.options = response.data.data
	          } else {
	          	vm.options = []
	          }
	        });
      	} else {
      		vm.options = []
      	}
   		}, 300),
	    closeMenu() {
	      this.$emit('close')
	    },
	    createNewChat() {
	      if (this.newMembers.length > 0) {
        this.createChatLoading = true
                
        gsApi.chat.create({
          type: this.newMemberIds.length > 1 ? 'group' : 'single',
	          members: this.newMemberIds,
        })
          .then((response) => {
            
	          if (response && response.data) {
              this.$store.commit(
                "UPDATE_SELECTED_CHAT",
                response.data
              );
	          	this.$events.emit('chatCreated', response.data)
	          	this.closeMenu()
	          } else {
	          	this.createChatLoading = false
	          	//handle-error
	          }
          })
          .catch(error => {
            this.createChatLoading = false
            if (
              error &&
              error.response &&
              error.response.data &&
              error.response.data.existingChat
            ) {
              this.closeMenu()
              this.$store.commit(
                "UPDATE_SELECTED_CHAT",
                error.response.data.existingChat
              );
            }
          });
	      }
	    },
	    removeMember(member) {
	      const index = _.findIndex(this.newMembers, {id: member.id})
	      this.newMembers.splice(index, 1)
	    },
  	}
}
</script>
